/**
 * Pure TS mirror of mcStatusTransitionOk() in firestore.rules (pre-work for
 * Fabrication Measurement, council B7). Kept in sync by
 * tests/firestore-rules/measurements.test.ts + this file's unit suite.
 *
 * Mirrors the NON-ADMIN machine: forward-only with skips, CANCELLED from any
 * non-terminal, never APPROVED (client approval is the admin-exempt branch —
 * the UI approve button is already role-gated to ADMIN). Same-status writes
 * are permitted by the rule but are not an "advance", so they return false
 * here — callers use this to gate transition BUTTONS, not saves.
 */
import type { MeasurementStatus } from '../../../types';

const FORWARD_CHAIN: readonly MeasurementStatus[] = [
  'PENDING_SCHEDULING',
  'SCHEDULED',
  'IN_PROGRESS',
  'COMPLETED',
];

export const canAdvanceMeasurement = (from: MeasurementStatus, to: MeasurementStatus): boolean => {
  if (from === to) return false;
  if (from === 'APPROVED' || from === 'CANCELLED') return false;
  if (to === 'CANCELLED') return true; // from is non-terminal here
  if (to === 'APPROVED') return false; // never a client advance
  const fromIdx = FORWARD_CHAIN.indexOf(from);
  const toIdx = FORWARD_CHAIN.indexOf(to);
  return fromIdx !== -1 && toIdx !== -1 && toIdx > fromIdx;
};
